import React from "react";
import img1 from "../../images/manufacturerBenefits/service (1).svg";
import img2 from "../../images/manufacturerBenefits/organic.svg";
import img3 from "../../images/manufacturerBenefits/search.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function LogisticStackFeature() {
  const benefits = [
    {
      img: img1,
      title: "Booking Status Management ",
      bodycopy: "Access to a comprehensive history of each booking's status, aiding in monitoring progress and maintaining accurate records."    },
    {
      img: img2,
      title: "View Booking and Order Details",
      bodycopy: " Comprehensive access to detailed booking information and associated orders, facilitating clear oversight and management.",
    },
    {
      img: img3,
      title: "Track Booking Status",
      bodycopy:
        " Real-time updates on booking statuses, enabling prompt responses to changes and effective communication with stakeholders.",
    },
    {
        img: img3,
        title: "Invoice Management",
        bodycopy:
          " Easy access to invoice URLs, simplifying billing procedures and ensuring financial transparency.    ",
      },
      {
        img: img3,
        title: "Booking Statistics",
        bodycopy:
          "Tracking of booking and trip counts to provide valuable insights for analyzing performance and identifying trends.",
      },

      {
        img: img3,
        title: "Driver-Specific Features",
        bodycopy:
          " Tools for drivers to view their assigned bookings and manage related orders and trips efficiently.",
      },
      {
        img: img3,
        title: " Create and Manage Requests",
        bodycopy:
          "Easily create and manage transport and storage requests, ensuring smooth handling of assets and products.",
      },
      {
        img: img3,
        title: " Real-Time Status Tracking",
        bodycopy:
          "Monitor the real-time status of transport and storage requests, keeping you informed about each step of the process.",
      },
      {
        img: img3,
        title: " Request Assignment",
        bodycopy:
          "Assign transport requests to logistics providers and storage requests to designated sites or warehouses.",
      },
      {
        img: img3,
        title: " Manage Transport and Storage Assets",
        bodycopy:
          "Track and manage assets and products involved in transportation or storage with detailed asset specifications.",
      },
      {
        img: img3,
        title: " Comprehensive Reporting",
        bodycopy:
          "Generate detailed reports on requests, including transport routes, storage durations, and asset conditions.",
      },
  ];
  return (
    <div className="main-wrapper">
          <Container className="subSectionWrapper ">
      <h2 className="text-center container-title mb-4">
          Features
      </h2>
      <Row>
        {benefits.map((e,index) => {
          return (
            <Col md={4} key={index} className="d-flex">
              <BenefitsCard src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
      </Container>
    </div>
  );
}
